import React from 'react';
import styled from '@emotion/styled';
import {css} from '@emotion/react';
import Image from 'gatsby-image';
import Layout from '../components/layout';
import { graphql } from 'gatsby';

import ProductosRel from '../components/productosComponents/ProductosRel';
import useResponsive from '../hooks/useResponsive';
const { size,device,ScreenWidth } = useResponsive();

export const query = graphql`
    query ($id: String!) {
        allStrapiProductos(filter: {id: {eq: $id}}) {
            nodes {
                categoria {
                    Nombre
                }
                subcategoria {
                    nombre
                }
                imagen {
                    childImageSharp{
                        fluid (maxWidth:1200){
                            ...GatsbyImageSharpFluid_withWebp
                        }
                    }
                }
                mg
                ml
                tabletas
                nombre
                subtitulo
                id
                descripcion
                aplicacion
                beneficios
                }
            }
        }
`;
        
const ProductContainer = styled.div`
    display:grid;
    grid-template-columns:1fr 2.5fr;
    column-gap:5rem;
    position:relative;
    @media ${device.mobileAll}{
        grid-template-columns:1fr;
    }
    @media ${device.tabletAll}{
        column-gap:0rem;
    }
    &:before{
        content:'';
        height:100%;
        width:100%;
        clip-path: polygon(0 0, 0 100%, 25% 0);
        background:linear-gradient(69deg, rgba(147,19,72,1) 5%, rgba(106,52,143,1) 20%, rgba(203,21,97,1) 37%);
        position: absolute;
        z-index:0;
        @media ${device.mobileAll}{
            display:none;
        }
    }
`;

const ImagenContainer = styled.div`
    padding:3rem;
    min-width:30rem;
    @media ${device.mobileAll}{
        min-width:5rem;
        width:7rem;
        padding:0 1rem 0 0;
    }
`;

const ContentContainer = styled.div`
    padding:2rem;
    position:relative;
`;

const HeaderContainer = styled.div`
    margin-bottom:2rem;
    position:relative;
    padding:0 5rem 1rem 0;
    @media ${device.mobileAll}{
        display:flex;
        padding-top:1rem;
        padding-left:2rem;
        border-bottom:3px solid var(--txcolor);
        border-radius:3%;
        margin-right:8%;
        .productName{
            display:flex;
            flex-direction:column;
            justify-content:flex-end;
            padding-left:1rem;
        }
    }
    &:before{
        content:'';
        height:5px;
        width:40%;
        min-width:250px;
        background-color:var(--brcolor);
        position: absolute;
        left:0;
        bottom:0;
        clip-path: polygon(0 0, 0 100%, 100% 50%);
        @media ${device.mobileAll}{
            display:none;
        }
    }
    
    h1{
        color:var(--txcolor);
        font-family:Roboto, sans-serif;
    }
    h2{
        font-size:1.5rem;
        
    }
`;

const Descripcion = styled.div`
    overflow: auto;
    max-height: 45vh;
    padding:2rem 4rem;
    border-radius:5px;
    border-bottom:5px solid #2b2e32;
    background:linear-gradient(325deg, rgba(24,24,24,0) 0%, rgba(43,46,50,0.20211834733893552) 50%, rgba(17,17,17,0.20211834733893552) 100%);
    white-space: pre-wrap;
    @media ${device.mobileSmall}{
        padding:2rem;
    }
    p{
        color:var(--txcolor70);
        line-height:1.6;
        font-size:1.5rem;
        margin-bottom:3rem;
        white-space: pre-wrap;
    }

    &::-webkit-scrollbar{
        background:#00000050 !important;
        border-radius:5px;
        width:.3em;
    }
    &::-webkit-scrollbar-thumb {
        background: #eaeaea;
        border-radius: 5px;
    }
    
`;

const DescTitle = styled.h4`
    padding:1rem 1rem;
    margin-bottom:1rem !important;
    letter-spacing:1px;
    position:relative;
    font-weight:700;
    font-family:QuubNormal;
    font-size:1.6rem;
    &:before{
        content:'';
        height:5px;
        width:35%;
        min-width:100px;
        background-color:var(--brcolor);
        position: absolute;
        left:0;
        bottom:0;
        clip-path: polygon(0 0, 0 100%, 100% 50%);
    }
`;

const MoreInfo = styled.div`

    margin-top:2rem;
    background:linear-gradient(325deg, rgba(24,24,24,1) 0%, rgba(43,46,50,1) 50%, rgba(24,24,24,1) 100%);
    box-shadow:-3px -3px 10px #2b2e32;
    border-radius:3px;
    @media ${device.tabletAll}{

    }
    ul{
        display:grid;
        grid-template-columns:repeat(3,1fr);
        padding:1rem;
        @media ${device.mobileSmall}{
            grid-template-columns:1fr;
            li{ 
                border-right:none !important;
                border-bottom:1px solid #444;
                padding-bottom:.5rem;
                margin-bottom:.5rem;
                &:last-of-type{
                    border:none;
                }
            }
            
        }
        li{
            border-right:1px solid #444;
            font-family:QuubMedium, sans-serif;
            letter-spacing:1px;
            h3{
                
            }
            &:last-of-type{
                border:none;
            }
        }
    }
    li,p{
        text-align:center;
    }
`;

const ProductsRelSection = styled.section`
    margin:0 12rem 5rem 5rem;
    background:linear-gradient(325deg, rgba(24,24,24,.60) 0%, rgba(43,46,50,.60) 50%, rgba(24,24,24,.60) 100%);
	padding:2em;
	border-radius:3px;
	border-top:5px solid #CB1561;
	box-shadow:10px 10px 2px #6a348f;
    min-width:650px;
    h2{
        color:var(--txcolor);
        margin-bottom:2rem !important; 
        border-left:5px solid; 
        padding-left:2rem;
        font-family: QuubMedium, sans-serif;
        letter-spacing:1px;
    }
    @media ${device.tabletAll}{
        margin:0 8rem 5rem 5rem;
        min-width:300px;
    }
`;


export default function producto({data: {allStrapiProductos: {nodes} } }) {

    const Width = ScreenWidth();
    const {nombre, subtitulo, descripcion, ml, mg, tabletas, imagen, categoria, beneficios, aplicacion, subcategoria} = nodes[0];

    return (
        <Layout>
            <article css={css`
            @media ${device.mobileAll}{
                padding:2rem 1rem;
            }
            padding:5rem;
            
            `}>
                <ProductContainer>
                    {(Width > size.mobile_max) &&
                    <ImagenContainer>
                        <Image fluid={imagen.childImageSharp.fluid} alt={nombre}/>
                    </ImagenContainer>
                    }
                    
                    <ContentContainer>

                        <HeaderContainer>
                            {(Width < size.mobile_max) ?
                            <>
                                <ImagenContainer>
                                    <Image fluid={imagen.childImageSharp.fluid} alt={`SGL ${nombre}`}/>
                                </ImagenContainer>
                                <div className='productName'>
                                    <h1> {nombre} </h1>
                                    {subtitulo!=null && 
                                    <h2> {subtitulo} </h2>
                                    }
                                </div>
                            </>
                            :
                            <>
                            <h1> {nombre} </h1>
                            {subtitulo!=null && 
                            <h2> {subtitulo} </h2>
                            }
                            </>
                            }
                        </HeaderContainer>
                        

                        <div css={css`
                            padding-right:5rem;
                            @media ${device.tabletAll}{
                                padding-right:0rem;
                            }
                        `}>
                            <Descripcion>
                                <p>{descripcion}</p>
                                {beneficios!=null && 
                                    <div>
                                        <DescTitle>Beneficios</DescTitle>
                                        <p>{beneficios}</p>
                                    </div>
                                }
                                {aplicacion!=null &&
                                    <div >
                                        <DescTitle>Aplicación</DescTitle>
                                        <p>{aplicacion}</p>
                                    </div>
                                }
                            </Descripcion>
                            
                            <MoreInfo>
                                <ul>
                                    {mg!=null && 
                                        <li>
                                            <h3>MG</h3> <p> {mg} </p>
                                        </li>
                                    }
                                    {tabletas!=null && 
                                        <li>
                                            <h3>Capsulas</h3> <p> {tabletas} </p>
                                        </li>
                                    }
                                    {ml!=null && 
                                        <li>
                                            <h3>Víal ML</h3> <p> {ml} </p>
                                        </li>
                                    }
                                    <li css={css`
                                            display:flex;
                                            align-items:center;
                                            flex-direction:column;
                                        `}>
                                        <p css={css`color:var(--s1color);font-weight:700;`}> { categoria.Nombre } </p>
                                         {subcategoria!= null && <p css={css`font-size:1.4rem;`} >{subcategoria.nombre}</p>}
                                    </li>
                                </ul>
                            </MoreInfo>
                        </div>
                    </ContentContainer>
                </ProductContainer>
            </article>

            <ProductsRelSection>
                <h2>Productos relacionados</h2>
                <ProductosRel ctgActual={categoria} />
            </ProductsRelSection>

        </Layout>
        
    )
}
